"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLabProcedures = createLabProcedures;
const events_1 = require("../../../events");
const common_1 = require("../../../utils/common");
const shared_1 = require("../../shared");
const createTotalUrineAnalysis_1 = require("./createTotalUrineAnalysis");
const queries_1 = require("../queries");
const messages = {
    labProcedures: {
        id: "ktx.dashboard.lab_procedures",
        defaultMessage: "Laborvizsgálatok"
    }
};
const numberTypeQueryList = Object.values(queries_1.numberTypeLabProcedureQueries);
const posNegTypeQueryList = Object.values(queries_1.posNegTypeLabProcedureQueries);
const summaryTypeQueryList = Object.values(queries_1.summaryTypeLabProcedureQueries);
function createLabProcedures(intl, options) {
    const { formatMessage } = intl;
    const { events } = options;
    const numberTypeEvents = (0, events_1.findEventsByQueries)(events, numberTypeQueryList);
    const totalUrineAnalysis = (0, createTotalUrineAnalysis_1.createTotalUrineAnalysis)(intl, options);
    const numberTypeRecords = numberTypeEvents.filter(common_1.isDefined).map(event => {
        if (typeof event.value === "number") {
            return (0, shared_1.createNumberRecordFromEvent)(intl, {
                label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(event.interpretation)],
                event: { ...event, value: event.value }
            });
        }
        else {
            return (0, shared_1.createNumberValueRecordFromEvent)(intl, {
                label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(event.interpretation)],
                event: { ...event, value: event.value }
            });
        }
    });
    const posNegTypeEvents = (0, events_1.findEventsByQueries)(events, posNegTypeQueryList);
    const posNegTypeRecords = posNegTypeEvents.filter(common_1.isDefined).map(event => (0, shared_1.createFormattedMessageValueRecordFromEvent)(intl, {
        label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(event.interpretation)],
        event,
        messages: shared_1.positiveNegativeInProgressMessages
    }));
    const summaryTypeEvents = (0, events_1.findEventsByQueries)(events, summaryTypeQueryList);
    const summaryTypeRecords = summaryTypeEvents
        .filter(common_1.isDefined)
        .map(event => {
        return {
            type: "record",
            label: formatMessage(shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(event.interpretation)]),
            attachments: (0, events_1.mapEventsToAttachments)(event),
            value: event.value.summary,
            timestamp: event.timestamp,
            origin: event.origin
        };
    });
    const content = (0, shared_1.createSectionContent)([
        ...numberTypeRecords,
        ...posNegTypeRecords,
        ...summaryTypeRecords,
        totalUrineAnalysis
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.labProcedures, content });
}
